export default __webpack_public_path__ + "recenter-960-e089b2042bb7553076a8e2e7a59e1d95.png";